/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthResult } from '@nebular/auth';
import { NbAuthService } from '@nebular/auth/services/auth.service';
import { UserService } from '../../../../@core/data/user.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { ProjectsService } from '../../../../@core/data/projects.service';


@Component({
  selector: 'ngx-logout',
  template: `
    <div class="text-center title mb-5">
      <img class="img-fluid" src={{logo}} alt="Logo">
    </div>
    <h3 class="text-center">Estás saliendo del sistema, espera...</h3>
  `,
})
export class NgxLogoutComponent implements OnInit {

  logo: string;

  redirectDelay = 1500;

  constructor(
    protected service: NbAuthService,
    protected router: Router,
    private userService: UserService,
    private http: HttpClient,
    private projectsService: ProjectsService,
  ) {
    try {
      const headers: HttpHeaders = new HttpHeaders({
        'Content-Type': 'application/json',
      });
      const options =  {headers: headers};
      this.http
        .get('https://server.sinecta.com/api/v1/domains', options)
        .subscribe(
          (result: any) => {
            const full = window.location.host;
            const parts = full.split('.');
            const sub = parts[0];
            if (sub.includes('localhost') || sub.includes('159')) {
              // return this.logo = 'https://server.sinecta.com/assets/images/domains/sinecta_white.png';
              return this.logo = 'https://app.sinecta.com/assets/images/aura_gds_white.png';
            }
            const domains = result.find(d => d['name'] === sub);
            if (domains) {
              if (sub.includes('sinecta') || sub.includes('localhost')) { // sinecta.ana-ia.com
                return this.logo = 'https://server.sinecta.com/assets/images/domains/logoseguros.jpg';
              } else {
                return this.logo = `https://server.sinecta.com/assets/images/domains/${domains['image']}`;
              }
            } else { // app.sinecta.com
              // return this.logo = 'https://server.sinecta.com/assets/images/logoseguros-app.jpg';
              return this.logo = 'https://app.sinecta.com/assets/images/aura_gds_white.png';
            }
          });
    } catch (error) {
      console.log(error);
    }
  }



  ngOnInit(): void {
    this.userService.logout().then(response => {
      if (response) {
        this.logout('email');
        localStorage.clear();
        sessionStorage.clear();
      } else {
        throw new Error('Something went terribly wrong');
      }
    });
  }

  clearLocalStorage() {
    localStorage.removeItem('map');
    localStorage.removeItem('searchMap');
    localStorage.removeItem('projects');
    localStorage.removeItem('search');
    localStorage.removeItem('searchTags');
    localStorage.removeItem('sort');
    localStorage.removeItem('sortDirection');
    localStorage.removeItem('pageIndex');
    localStorage.removeItem('tab_actual');
    localStorage.removeItem('orderName');
    localStorage.removeItem('orderBy');
  }

  logout(provider: string): void {
    try {
      this.projectsService.clearProjects();
      this.service.logout(provider).subscribe((result: NbAuthResult) => {
        this.clearLocalStorage();
        const redirect = result.getRedirect();
        if (redirect) {
          setTimeout(() => {
            return this.router.navigateByUrl(redirect);
          }, this.redirectDelay);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
}
